/* global mixpanel */

export function libraryDiscountStart ({outletId}) {
  mixpanel.track('Library Discount Start', {
    'Current Selected Outlet': outletId
  })
}

export function libraryDiscountChangeOutlet ({prevOutlet, currOutlet}) {
  mixpanel.track('Library Discount Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet
  })
}

export function libraryDiscountCreate ({discount, allOutlet}) {
  const eventName = (allOutlet) ? 'Library Discount Create All Outlet' : 'Library Discount Create One Outlet'
  mixpanel.track(eventName, {
    'Name': discount.name,
    'Type': discount.type
  })
}

export function libraryDiscountUpdate ({oldDiscount, newDiscount}) {
  mixpanel.track('Library Discount Update One Outlet', {
    'Old Name': oldDiscount.name,
    'Old Type': oldDiscount.type ? 'percentage' : 'rupiah',
    'New Name': newDiscount.name,
    'New Type': newDiscount.type
  })
}

export function libraryDiscountDelete ({discount}) {
  mixpanel.track('Library Discount Delete', {
    'Name': discount.name,
    'Type': discount.type
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/discount.js